export default "__VITE_ASSET__DJWO0PdV__"